export default __webpack_public_path__ + "static/glyphicons-halflings-white.4c0c08627c5e2847896bc8057c4dd929.png";